import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { b as bankAccountTypeOptions } from './business-form-options.js';
import './event-types.js';
import { n as numberOnlyHandler } from './utils3.js';
import { d as defineCustomElement$4 } from './custom-popper2.js';
import { d as defineCustomElement$3 } from './form-control-select2.js';
import { d as defineCustomElement$2 } from './form-control-text2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const BankAccountFormInputs = /*@__PURE__*/ proxyCustomElement(class BankAccountFormInputs extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.defaultValue = undefined;
        this.errors = undefined;
        this.inputHandler = undefined;
        this.formDisabled = undefined;
    }
    render() {
        return (h("div", { key: 'c4420b1e4396ac065b3674f52b124c0d25359435', class: "row gy-3" }, h("div", { key: '40e5f2d54a6f60558ec5aa50ff47e6adcf66276b', class: "col-12" }, h("form-control-text", { key: '9052ecb4597ecc96841d65929f1d8e5dbf662343', name: "bank_name", label: "Bank Name", defaultValue: this.defaultValue.bank_name, errorText: this.errors.bank_name, inputHandler: this.inputHandler, disabled: this.formDisabled })), h("div", { key: 'c32bbaf4fe2155f49cb35ee4500016e7f97f24b3', class: "col-12" }, h("form-control-text", { key: '3527553824fb36ea616836bf8e9435fc33a2365a', name: "nickname", label: "Nickname", defaultValue: this.defaultValue.nickname, errorText: this.errors.nickname, inputHandler: this.inputHandler, disabled: this.formDisabled })), h("div", { key: 'c203663fad98052567b34cbffe316606c963ff23', class: "col-12" }, h("form-control-text", { key: 'db95259c41fa10b6af2cbc4c9bd7340d609312ee', name: "account_owner_name", label: "Account Owner Name", defaultValue: this.defaultValue.account_owner_name, errorText: this.errors.account_owner_name, inputHandler: this.inputHandler, disabled: this.formDisabled })), h("div", { key: '3228e30c418210556e4e9f99f4f87f753876072d', class: "col-12" }, h("form-control-select", { key: '6dde33c0e9a2ac76051e01af836ea372f30d8fbb', name: "account_type", label: "Account Type", options: bankAccountTypeOptions, defaultValue: this.defaultValue.account_type, errorText: this.errors.account_type, inputHandler: this.inputHandler, disabled: this.formDisabled })), h("div", { key: '266005f1bba23068fc0be35416f5fd8cf3fc7c7c', class: "col-12" }, h("form-control-text", { key: '34caa85c53b457de98a524a2eb151899e5bcf21a', name: "account_number", label: "Account Number", defaultValue: this.defaultValue.account_number, maxLength: 17, errorText: this.errors.account_number, inputHandler: this.inputHandler, keyDownHandler: numberOnlyHandler, disabled: this.formDisabled, helpText: "Please copy the account number as shown on your statement/check. Do not include spaces or dashes." })), h("div", { key: '69d2e72cf588518e4fe310c2ad5cb37c72fab8c6', class: "col-12" }, h("form-control-text", { key: 'bc4353e36c9d982aa55f5e933975c4020c316ad0', name: "routing_number", label: "Routing Number", defaultValue: this.defaultValue.routing_number, maxLength: 9, errorText: this.errors.routing_number, inputHandler: this.inputHandler, keyDownHandler: numberOnlyHandler, disabled: this.formDisabled, helpText: "A valid routing number is nine digits. Please include any leading or trailing zeroes." }))));
    }
}, [0, "bank-account-form-inputs", {
        "defaultValue": [8, "default-value"],
        "errors": [8],
        "inputHandler": [16],
        "formDisabled": [4, "form-disabled"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bank-account-form-inputs", "custom-popper", "form-control-select", "form-control-text", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "bank-account-form-inputs":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BankAccountFormInputs);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { BankAccountFormInputs as B, defineCustomElement as d };
